<template>
    <g :font-family="fontFamily" :font-size="14">
        <g v-if="display">
            <rect
                :x="margin"
                :y="(height - track) / 2"
                :width="width - margin * 2"
                :height="track"
                :fill="background"
                stroke="transparent"
            />
        </g>

        <line
            :x1="margin"
            :y1="height / 2 + (track * 3) / 2"
            :x2="margin"
            :y2="height / 2 - (track * 3) / 2"
            stroke="rgb(98, 97, 102)"
        />

        <line
            :x1="width - margin"
            :y1="height / 2 + (track * 3) / 2"
            :x2="width - margin"
            :y2="height / 2 - (track * 3) / 2"
            stroke="rgb(98, 97, 102)"
        />

        <g v-if="display">
            <rect
                :x="position(min)"
                :width="position(max) - position(min)"
                :y="height / 2 - 8"
                :height="16"
                :fill="foreground"
                stroke="transparent"
                v-if="min && max"
            />

            <line
                :x1="position(min)"
                :x2="position(min)"
                :y1="height / 2 - 8"
                :y2="height / 2 + 8"
                stroke="#fbb323"
                stroke-width="3"
                v-if="min && min !== max"
            />

            <line
                :x1="position(max)"
                :x2="position(max)"
                :y1="height / 2 - 8"
                :y2="height / 2 + 8"
                stroke="#fbb323"
                stroke-width="3"
                v-if="max && min !== max"
            />

            <circle
                :cx="((val - 1) / 4) * (width - margin * 2) + margin"
                :cy="height / 2"
                r="16"
                :fill="foreground"
                stroke="white"
            />

            <text
                :x="((val - 1) / 4) * (width - margin * 2) + margin"
                :y="height / 2 + 5"
                font-size="14"
                text-anchor="middle"
                fill="white"
            >
                {{ display }}
            </text>
        </g>

        <text :x="width / 2" :y="height / 2" text-anchor="middle" fill="black" v-if="!display"> N/A </text>

        <g class="slider-label-static" fill="rgb(98, 97, 102)" text-anchor="middle" v-if="scale">
            <text :x="margin" :y="height">1</text>

            <text :x="width - margin" :y="height">5</text>
        </g>
    </g>
</template>
<script>
export default {
    props: {
        background: {
            type: String,
            default: 'rgb(173, 240, 249)',
        },
        foreground: {
            type: String,
            default: 'rgb(0, 201, 234)',
        },
        fontFamily: {
            type: String,
            default: 'Lato',
        },
        max: {
            type: Number,
        },
        min: {
            type: Number,
        },
        value: {
            type: Number,
        },
        height: {
            type: Number,
            default: 40,
        },
        scale: {
            type: Boolean,
            default: true,
        },
        width: {
            type: Number,
        },
    },
    computed: {
        box() {
            return 4
        },
        display() {
            if (this.value) {
                return this.value.toFixed(1)
            }

            return null
        },
        margin() {
            return 20
        },
        track() {
            return 4
        },
        val() {
            return this.value
        },
    },
    methods: {
        position(value) {
            return ((value - 1) / 4) * (this.width - this.margin * 2) + this.margin
        },
    },
}
</script>
